<template>
  <header class="font-sans sticky top-0 z-50 w-full bg-white dark:bg-[#1a202c] border-b border-[#e7ebf3] dark:border-gray-700 transition-all duration-300">
    <div class="max-w-[1280px] mx-auto px-4 lg:px-10">
      <div class="flex items-center justify-between h-20">
        <!-- Logo Area -->
        <div class="flex items-center gap-3 text-[#0d121b] dark:text-white">
          <router-link to="/" class="flex items-center gap-3">
            <img alt="Logo" class="w-12 h-12 object-contain" src="/logo.png"/>
            <div class="flex flex-col justify-center">
              <h1 class="text-xl font-bold leading-none tracking-widest text-[#0d121b] dark:text-white">湖北省建筑劳务协会</h1>
              <div class="flex justify-between w-full text-[8px] text-[#4c669a] uppercase font-bold mt-1 gap-1">
                <span>Hubei</span>
                <span>Construction</span>
                <span>Labor</span>
                <span>Association</span>
              </div>
            </div>
          </router-link>
        </div>

        <!-- Desktop Navigation -->
        <nav class="hidden lg:flex items-center gap-8">
          <router-link 
            to="/" 
            class="nav-link text-sm font-medium transition-colors hover:text-primary relative py-2"
            active-class="text-primary font-bold active-link"
          >
            首页
          </router-link>
          <router-link 
            to="/about" 
            class="nav-link text-sm font-medium transition-colors hover:text-primary relative py-2"
            active-class="text-primary font-bold active-link"
            :class="{ 'text-primary font-bold active-link': $route.path.startsWith('/about') }"
          >
            协会概况
          </router-link>
          <router-link 
            to="/news" 
            class="nav-link text-sm font-medium transition-colors hover:text-primary relative py-2"
            active-class="text-primary font-bold active-link"
            :class="{ 'text-primary font-bold active-link': $route.path.startsWith('/news') }"
          >
            新闻中心
          </router-link>
          <router-link 
            to="/policy" 
            class="nav-link text-sm font-medium transition-colors hover:text-primary relative py-2"
            active-class="text-primary font-bold active-link"
            :class="{ 'text-primary font-bold active-link': $route.path.startsWith('/policy') }"
          >
            政策法规
          </router-link>
          <router-link 
            to="/service" 
            class="nav-link text-sm font-medium transition-colors hover:text-primary relative py-2"
            active-class="text-primary font-bold active-link"
            :class="{ 'text-primary font-bold active-link': $route.path.startsWith('/service') }"
          >
            会员服务
          </router-link>
          <router-link 
            to="/contact" 
            class="nav-link text-sm font-medium transition-colors hover:text-primary relative py-2"
            active-class="text-primary font-bold active-link"
            :class="{ 'text-primary font-bold active-link': $route.path.startsWith('/contact') }"
          >
            联系我们
          </router-link>
        </nav>

        <!-- Right Actions -->
        <div class="flex items-center gap-4">
          <button @click="goToLogin" class="hidden md:flex bg-primary hover:bg-blue-700 text-white px-5 py-2 rounded-lg text-sm font-bold shadow-md transition-colors items-center gap-2">
            <span class="material-symbols-outlined text-lg">login</span>
            <span>登录</span>
          </button>
          <button @click="toggleMenu" class="lg:hidden p-2 text-[#0d121b] dark:text-white hover:bg-gray-100 dark:hover:bg-gray-800 rounded transition-colors">
            <span class="material-symbols-outlined">{{ isMenuOpen ? 'close' : 'menu' }}</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile Menu -->
    <div v-show="isMenuOpen" class="lg:hidden absolute top-20 left-0 w-full bg-white dark:bg-[#1a202c] border-b border-[#e7ebf3] dark:border-gray-700 shadow-lg p-4 flex flex-col gap-2 z-50">
      <router-link to="/" class="p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 font-medium" active-class="text-primary bg-blue-50 dark:bg-gray-800" @click="isMenuOpen = false">首页</router-link>
      <router-link to="/about" class="p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 font-medium" active-class="text-primary bg-blue-50 dark:bg-gray-800" :class="{ 'text-primary bg-blue-50 dark:bg-gray-800': $route.path.startsWith('/about') }" @click="isMenuOpen = false">协会概况</router-link>
      <router-link to="/news" class="p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 font-medium" active-class="text-primary bg-blue-50 dark:bg-gray-800" :class="{ 'text-primary bg-blue-50 dark:bg-gray-800': $route.path.startsWith('/news') }" @click="isMenuOpen = false">新闻中心</router-link>
      <router-link to="/policy" class="p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 font-medium" active-class="text-primary bg-blue-50 dark:bg-gray-800" :class="{ 'text-primary bg-blue-50 dark:bg-gray-800': $route.path.startsWith('/policy') }" @click="isMenuOpen = false">政策法规</router-link>
      <router-link to="/service" class="p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 font-medium" active-class="text-primary bg-blue-50 dark:bg-gray-800" :class="{ 'text-primary bg-blue-50 dark:bg-gray-800': $route.path.startsWith('/service') }" @click="isMenuOpen = false">会员服务</router-link>
      <router-link to="/contact" class="p-3 rounded-lg hover:bg-gray-50 dark:hover:bg-gray-800 font-medium" active-class="text-primary bg-blue-50 dark:bg-gray-800" :class="{ 'text-primary bg-blue-50 dark:bg-gray-800': $route.path.startsWith('/contact') }" @click="isMenuOpen = false">联系我们</router-link>
      
      <div class="h-px bg-gray-100 dark:bg-gray-700 my-1"></div>
      
      <button @click="goToLogin" class="flex w-full bg-primary hover:bg-blue-700 text-white px-5 py-3 rounded-lg text-sm font-bold shadow-md transition-colors items-center justify-center gap-2">
        <span class="material-symbols-outlined text-lg">login</span>
        <span>登录</span>
      </button>
    </div>
  </header>
</template>

<script>
export default {
  name: 'AppHeader',
  data() {
    return {
      isMenuOpen: false
    }
  },
  methods: {
    toggleMenu() {
      this.isMenuOpen = !this.isMenuOpen;
    },
    goToLogin() {
      this.isMenuOpen = false;
      this.$router.push('/login');
    }
  }
}
</script>

<style scoped>
.nav-link {
  color: #0d121b;
}
:global(.dark) .nav-link {
  color: #e2e8f0;
}
.nav-link:hover {
  color: #135bec;
}
.active-link {
  color: #135bec !important;
}
.active-link::after {
  content: '';
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background-color: #135bec;
  border-radius: 2px;
}
</style>
